import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Categories = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  const cars = [
    {
      img: "img/nissan-note.png",
      title: "Nissan Note",
      price: "3,000/Day",
      review: "5.0",
      features: ["5 Seats", "2WD", "Petrol", "2024", "AUTO", "new"],
    },
    {
      img: "img/toyota-fielder.jpeg",
      title: "Toyota Filder",
      price: "3,500/Day",
      review: "4.9",
      features: ["5 Seats", "2WD", "Petrol", "2024", "AUTO", "new"],
    },
    {
      img: "img/toyota-axio.jpeg",
      title: "Toyota Axio",
      price: "3,500/Day",
      review: "4.9",
      features: ["5 Seats", "2WD", "Petrol", "2024", "AUTO", "new"],
    },
    {
      img: "img/toyota-alphard.png",
      title: "Toyota Alphard",
      price: "8,000/Day",
      review: "4.8",
      features: ["7 Seats", "4WD", "Petrol", "2023", "AUTO", "new"],
    },
    {
      img: "img/voxy.jpg",
      title: "Toyota Voxy",
      price: "7,000/Day",
      review: "4.8",
      features: ["7 Seats", "4WD", "Petrol", "2023", "AUTO", "new"],
    },
    {
      img: "img/toyota-noah.png",
      title: "Toyota Noah",
      price: "7,000/Day",
      review: "4.8",
      features: ["7 Seats", "4WD", "Petrol", "2023", "AUTO", "new"],
    },
    {
      img: "img/nissan-xtrail.png",
      title: "Nissan X-Trail",
      price: "8,000/Day",
      review: "4.5",
      features: ["4 Seats", "2WD", "Petrol", "2023", "AUTO", "new"],
    },
  ];
  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };
  const shuffledCars = shuffleArray([...cars]);

  return (
    <div className="container-fluid categories pb-5">
      <div className="container pb-5">
        <div
          className="text-center mx-auto pb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "800px" }}
        >
          <h1 className="display-5 text-capitalize mb-3">
            Vehicle <span className="text-primary">Categories</span>
          </h1>
          <p className="mb-0">
            Discover our wide range of vehicles for your adventures across
            Kenya. Whether it's for business or leisure, we've got the perfect
            car for you!
          </p>
        </div>
        <Slider {...settings} aria-label="Vehicle categories carousel">
          {shuffledCars.map((car, index) => (
            <div className="categories-item p-4" key={index}>
              <div className="categories-item-inner">
                <div className="categories-img rounded-top">
                  <img
                    src={car.img}
                    className="img-fluid w-100 rounded-top"
                    alt={car.title}
                  />
                </div>
                <div className="categories-content rounded-bottom p-4">
                  <h4>{car.title}</h4>
                  <div className="categories-review mb-4">
                    <div className="me-3">{car.review}</div>
                    <div className="d-flex justify-content-center text-secondary">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`fas fa-star ${
                            i < Math.floor(parseFloat(car.review))
                              ? ""
                              : "text-body"
                          }`}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="mb-4">
                    <h4 className="bg-white text-primary rounded-pill py-2 px-4 mb-0">
                      sh. {car.price}
                    </h4>
                  </div>
                  <div className="row gy-2 gx-0 text-center mb-4">
                    {car.features.map((feature, idx) => (
                      <div
                        className={`col-${
                          12 / car.features.length
                        } border-end border-white`}
                        key={idx}
                      >
                        <i
                          className={`fa ${
                            idx < 3 ? "fa-users" : "fa-car"
                          } text-dark`}
                        ></i>
                        <span className="text-body ms-1">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <Link
                    to="/bookings"
                    className="btn btn-primary rounded-pill d-flex justify-content-center py-3"
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Categories;
